/** Ported from v1 crew-app helpers/groupInventoryAcrossOrders.ts */

export type InventoryLine = {
  quantity?: number | null
  item: {
    id: number
    consumable?: boolean | null
    visibility?: { operatorAssignment?: string | null } | null
  }
}

export type OrderWithInventory<T extends InventoryLine> = {
  planned?: { inventory?: T[] | null } | null
} | null

/**
 * Aggregates the crew-visible inventory of every order in an assignment into
 * one de-duplicated load list: consumables sum quantities, non-consumables
 * (tools) take the max.
 */
export function groupInventoryAcrossOrders<T extends InventoryLine>(
  orders: Array<OrderWithInventory<T>>,
): T[] {
  const inventoryByItemId: Record<number, T> = {}

  for (const order of orders) {
    const visibleInventory = (order?.planned?.inventory ?? []).filter(
      (line) => line.item.visibility?.operatorAssignment !== 'hidden',
    )

    for (const lineItem of visibleInventory) {
      const itemId = lineItem.item.id
      const existing = inventoryByItemId[itemId]

      if (!existing) {
        inventoryByItemId[itemId] = { ...lineItem }
        continue
      }
      if (lineItem.quantity === undefined || lineItem.quantity === null) {
        continue
      }

      const currentQuantity = existing.quantity || 0
      existing.quantity = lineItem.item.consumable
        ? currentQuantity + lineItem.quantity
        : Math.max(currentQuantity, lineItem.quantity)
    }
  }

  return Object.values(inventoryByItemId)
}
